import * as R from "ramda";

type replaceWordFormat = {
  to: string;
  from: string | RegExp;
};

export const replaceWord = R.curry(
  (format: replaceWordFormat[], text: string) =>
    Array.isArray(format)
      ? format.reduce(
          (acc, { from, to }) => R.replace(from, to, acc),
          text || "",
        )
      : text,
);
